import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);
    const [quantities, setQuantities] = useState({});

    const addToCart = (product) => {
        setCartItems((prevItems) => {
            // 이미 같은 ID를 가진 제품이 있는지 확인하고 없으면 카트에 추가
            const isAlreadyInCart = prevItems.some(item => item.id === product.id);
            if (isAlreadyInCart) {
                return prevItems;
            }
            // 없는 경우, 새로운 제품 추가
            return [...prevItems, product];
        });
        setQuantities((prevQuantities) => ({
            ...prevQuantities,
            [product.id]: 1,
        }));
    };

    const removeFromCart = (productId) => {
        setCartItems((prevItems) => prevItems.filter(item => item.id !== productId));
        setQuantities((prevQuantities) => {
            const { [productId]: _, ...rest } = prevQuantities;
            return rest;
        });
    };

    const updateQuantity = (productId, quantity) => {
        setQuantities((prevQuantities) => ({
            ...prevQuantities,
            [productId]: quantity,
        }));
    };

    return (
        <CartContext.Provider value={{ cartItems, setCartItems, addToCart, removeFromCart, quantities, updateQuantity }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
